module.exports = __webpack_public_path__ + "static/media/ZA.2bc21610.svg";